import React from 'react';
import { useParams } from 'react-router-dom';
import { useBookings } from '../../../../hooks/accommodation';
import { useAppSelector } from '../../../../hooks/useRedux';
import { selectAccommodationProperty } from '../../../../store/accommodation';

function Detail({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="text-xs text-gray-400 font-medium">{label}</p>
      <p className="text-sm font-semibold text-gray-900 mt-0.5">{value}</p>
    </div>
  );
}

export const BookingGuestCard: React.FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const property = useAppSelector(selectAccommodationProperty);
  const { data: bookings = [] } = useBookings(property?.id);
  const booking = bookings.find((b) => b.id === bookingId) ?? null;

  if (!booking) return null;

  const guestName = booking.client
    ? `${booking.client.first_name} ${booking.client.last_name}`
    : '—';

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 space-y-3.5">
      <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-500 pb-2 border-b border-gray-100">
        Guest Info
      </h4>
      <div className="grid gap-x-6 gap-y-3 sm:grid-cols-2">
        <Detail label="Name" value={guestName} />
        <Detail label="Email" value={booking.client?.email ?? '—'} />
        <Detail label="Phone" value={booking.client?.contact ?? '—'} />
        <Detail
          label="Nationality"
          value={booking.client?.nationality ?? '—'}
        />
        <Detail
          label="Country"
          value={
            booking.guest_country?.name || booking.guest_country_name || '—'
          }
        />
        <Detail label="ID type" value={booking.client?.id_type ?? '—'} />
        <Detail label="ID number" value={booking.client?.id_number ?? '—'} />
      </div>
    </div>
  );
};
